import { aplicativoService } from '@/services/aplicativoService';

const state = {
  aplicativos: []
}

const getters = {
  aplicativos: state => state.aplicativos,
}

const actions = {
  async fetchAplicativos({ commit }, { page, limit, status, query }) {
    commit('SET_LOADING', true);
    try {
      const response = await aplicativoService.getAll(page, limit, status, query);
      commit('SET_APLICATIVOS', response.data.data);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_APLICATIVOS', []);
      commit('SET_LOADING', false);
    }
  },
  async addAplicativo({ commit }, aplicativo) {
    commit('SET_LOADING', true);
    try {
      const response = await aplicativoService.create(aplicativo);
      commit('SET_APLICATIVO', response.data.data);
      commit('SET_LOADING', false);
      return true;
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async updateAplicativo({ commit }, updAplicativo) {
    commit('SET_LOADING', true);
    try {
      const response = await aplicativoService.update(updAplicativo);
      commit('UPDATE_APLICATIVO', response.data.data);
      commit('SET_LOADING', false);
      return true;
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async deleteAplicativo({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      await aplicativoService.destroy(id);
      commit('DELETE_APLICATIVO', id);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
    }
  },
}

const mutations = {
  SET_APLICATIVOS: (state, aplicativos) => state.aplicativos = aplicativos,
  SET_APLICATIVO: (state, aplicativo) => state.aplicativos.push(aplicativo),
  UPDATE_APLICATIVO: (state, updAplicativo) => {
    const index = state.aplicativos.findIndex(aplicativo => aplicativo._id === updAplicativo._id)
    if (index !== -1) state.aplicativos.splice(index, 1, updAplicativo);
  },
  DELETE_APLICATIVO: (state, id) => state.aplicativos = state.aplicativos.filter(aplicativo => aplicativo._id !== id)
}

export default {
  state,
  getters,
  actions,
  mutations
}